import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["accept"]
const _hoisted_2 = { class: "upload-area-hint" }
const _hoisted_3 = {
  key: 1,
  class: "upload-file-grid"
}
const _hoisted_4 = {
  key: 1,
  class: "icon font-40",
  "aria-hidden": "true"
}
const _hoisted_5 = ["xlink:href"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "grid-item-name" }
const _hoisted_8 = { class: "grid-item-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ZPreview = _resolveComponent("ZPreview")!
  const _component_plus = _resolveComponent("plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_close = _resolveComponent("close")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_ctx.option.config.isAvatar)
    ? (_openBlock(), _createBlock(_component_el_upload, {
        key: 0,
        class: "avatar-uploader",
        headers: _ctx.headers,
        action: _ctx.upLoadUrl,
        accept: _ctx.accept,
        "show-file-list": _ctx.option.config.showFileList || false,
        "on-success": _ctx.handleSuccess,
        "on-error": _ctx.handleError,
        "before-upload": _ctx.beforeUpload,
        "on-exceed": _ctx.handleExceed
      }, {
        default: _withCtx(() => [
          (_ctx.value)
            ? (_openBlock(), _createBlock(_component_ZPreview, {
                key: 0,
                authSrc: _ctx.value,
                headers: _ctx.headers,
                baseUrl: _ctx.upLoadUrl,
                showPreview: false
              }, null, 8, ["authSrc", "headers", "baseUrl"]))
            : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "avatar-uploader-icon"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_plus)
                ]),
                _: 1
              }))
        ]),
        _: 1
      }, 8, ["headers", "action", "accept", "show-file-list", "on-success", "on-error", "before-upload", "on-exceed"]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "z-upload-wrapper",
        onPaste: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args)))
      }, [
        _createElementVNode("div", {
          ref: "uploadArea",
          class: _normalizeClass(["upload-area", { 'upload-area--dragover': _ctx.isDragOver }]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleAreaClick && _ctx.handleAreaClick(...args))),
          onDragover: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.isDragOver = true), ["prevent"])),
          onDragleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDragOver = false)),
          onDrop: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)))
        }, [
          _createElementVNode("input", {
            ref: "fileInput",
            type: "file",
            accept: _ctx.accept,
            multiple: "",
            style: {"display":"none"},
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args)))
          }, null, 40, _hoisted_1),
          (!_ctx.value || !_ctx.value.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_icon, { class: "upload-area-icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_upload_filled)
                  ]),
                  _: 1
                }),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "upload-area-text" }, "点击或拖拽、粘贴上传图片", -1)),
                _createElementVNode("div", _hoisted_2, "支持拖拽、点击选择、粘贴，最多" + _toDisplayString(_ctx.limit) + "张，单张不超过 50MB", 1)
              ], 64))
            : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "grid-item"
                  }, [
                    _createElementVNode("div", {
                      class: "grid-item-preview",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (item.fileType === 'image')
                        ? (_openBlock(), _createBlock(_component_ZPreview, {
                            key: 0,
                            authSrc: item.url,
                            headers: _ctx.headers,
                            baseUrl: _ctx.upLoadUrl,
                            width: String(80),
                            height: String(80)
                          }, null, 8, ["authSrc", "headers", "baseUrl", "width", "height"]))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                            _createElementVNode("use", {
                              "xlink:href": item.fileType
                            }, null, 8, _hoisted_5)
                          ])),
                      _createElementVNode("div", {
                        class: "grid-item-delete",
                        onClick: _withModifiers(($event: any) => (_ctx.handleDelete(index, item.url)), ["stop"])
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_close)
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_6)
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.url), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_link, {
                        underline: false,
                        onClick: _withModifiers(($event: any) => (_ctx.downLoadFile(item.url)), ["stop"]),
                        type: "primary"
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("下载", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_link, {
                        underline: false,
                        onClick: _withModifiers(($event: any) => (_ctx.handleDelete(index, item.url)), ["stop"]),
                        type: "danger"
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("删除", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
        ], 34)
      ], 32))
}